import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button,
  Stack,
  TableCell,
  Typography,
  DialogContentText,
} from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { TableWidgetV2, CustomFilterV2, DialogDefaultV2 } from '../../../components/v2';
import * as selectorsControlePontos from '../../../store/controlePonto/reducer';
import * as actionsControlePontos from '../../../store/controlePonto/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Roles from '../../../constants/role';
import Formulario from './Formulario';

const DEFAULT_FILTER = { ativo: true };

const ControlePontoV2 = ({ controlePontoUsuarios, loadControlePontoUsuarios, authData, exportControlePonto }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState(DEFAULT_FILTER);
  const [openExport, setOpenExport] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const defaultFilterMemo = useMemo(() => ({ ...DEFAULT_FILTER }), []);

  const filterFields = useMemo(
    () => [
      {
        field: 'useAtivo',
        useAtivoLabel: 'Usuário Ativo',
        md: 12,
        xs: 12,
      },
      {
        field: 'useUsuarios',
        key: 'usuarioId',
        label: 'Usuário',
        multiSelect: true,
        md: 12,
        xs: 12,
        regimeTrabalhoIds: ['384aa79b-0ce2-4b45-9c55-ae20ec5c5e21'],
        ativo: localFilter.ativo,
      },
    ],
    [localFilter.ativo],
  );

  useEffect(() => {
    loadControlePontoUsuarios(localFilter);
  }, [loadControlePontoUsuarios]);

  const isAdmin = authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const onEdit = (rowId) => {
    setId(rowId);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setId(null);
    loadControlePontoUsuarios(localFilter);
  };

  const renderRows = (r) => (
    <>
      <TableCell>
        <Typography variant="body2">{r.nome}</Typography>
        <Typography variant="body2" color="text.secondary">{r.matricula}</Typography>
      </TableCell>
      <TableCell>{r.ativo ? 'Sim' : 'Não'}</TableCell>
      <TableCell>{r.saldo}</TableCell>
    </>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Controle de Ponto</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableWidgetV2
          rows={controlePontoUsuarios || []}
          titles={['Nome', 'Ativo', 'Saldo']}
          headerTitle="Controle de Ponto"
          renderRows={renderRows}
          hasAdd={false}
          showDelete={false}
          showEdit
          hasRowActions={isAdmin}
          onEdit={onEdit}
          headerActions={[{ title: 'Exportar', onClick: () => setOpenExport(true) }]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          defaultFilter={defaultFilterMemo}
          appliedFilter={localFilter}
          fields={[
            {
              field: 'useUsuarios',
              key: 'usuarioId',
              label: 'Usuário',
              multiSelect: true,
              md: 12,
              xs: 12,
              regimeTrabalhoIds: ["384aa79b-0ce2-4b45-9c55-ae20ec5c5e21"],
            },
          ]}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            loadControlePontoUsuarios(filterData);
            setOpenFilter(false);
          }}
        />
      </Stack>
      <Formulario id={id} open={open} onClose={onClose} />
      <DialogDefaultV2
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => exportControlePonto(localFilter, () => setOpenExport(false))}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>Deseja exportar todas as informações filtradas?</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  controlePontoUsuarios: selectorsControlePontos.getControlePontosUsuarios(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsControlePontos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ControlePontoV2);
